import gql from 'graphql-tag';

export const Company360ListQuery = gql`
	query Company360ListQuery(
		$first: Int
		$cursor: String
		$filter: Company360FilterInput
	) {
		entities: company360s(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					status
					companyLevel
					Company {
						id
						name
					}
					Service {
						id
						name
					}
					FoodService {
						id
						name
					}
					Retailer {
						id
						name
					}
					Brand {
						id
						name
					}
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;